import { addEventListener, fetch } from '@react-native-community/netinfo';
import React, { useEffect, useState } from 'react';
import Snackbar from 'shared/components/vxl/Snackbar/Snackbar';
import AlertStrings from 'shared/localization/localizedStrings/AlertStrings';

const NetworkStatus = () => {
  const [isConnected, setIsConnected] = useState<boolean | null>(true);

  useEffect(() => {
    fetch()
      .then((state) => {
        setIsConnected(state.isConnected);
      })
      .catch(() => {});
    const unsubscribe = addEventListener((state) => {
      setIsConnected(state.isConnected);
    });

    return () => unsubscribe();
  }, []);

  if (isConnected) {
    return null;
  }

  return <Snackbar text={AlertStrings.noInternetConnection} disableAutoHide />;
};

export default NetworkStatus;
